import React from 'react';

import { InfoMessage, WarningMessage } from '@eika/attention-message';
import { IconTypes } from '@eika/icon';
import { Link } from '@eika/link';
import { LinkCard } from '@eika/link-panel';

import { useConfig } from '../../../defaultConfig';
import { useAccount } from '../../../fetchHooks/useAccount';
import useProfile from '../../../fetchHooks/useProfile';
import useAccountId from '../../../hooks/queryparams/useAccountId';
import useTranslation from '../../../hooks/useTranslation';
import AccountBSURecurringPaymentMessage from './AccountBSURecurringPaymentMessage';

import './AccountBSUMessage.scss';

const AccountBSUMessage: React.FC = () => {
    const accountId = useAccountId();
    const { data: account } = useAccount(accountId);
    const translated = useTranslation();
    const { contactPageLink, accountDetailsLink } = useConfig();
    const { data: userInfo } = useProfile();

    const isLoggedInUserAccountOwnerAndOlderThan34 =
        account?.owners.find((a) => a?.primaryOwner)?.equalToUserLoggedOn && userInfo?.age && userInfo?.age > 34;

    return (
        <>
            {accountId?.value && accountDetailsLink && (
                <LinkCard
                    icon={IconTypes.INFO_DYN}
                    className="bsu-additional-info"
                    title={translated.accountDetails.seeAccountDetails}
                    textOne={translated.accountDetails.moreInfoAboutThisAccount}
                    url={`${accountDetailsLink.url}?id=${accountId.value}`}
                />
            )}
            <InfoMessage
                className="bsu-additional-info"
                text={translated.bsuDetails.infoMessage}
                icon={IconTypes.INFO_24}
                clickableItem={<Link href={contactPageLink?.url}>{translated.accountDetails.orgContact}</Link>}
            />
            <AccountBSURecurringPaymentMessage account={account} />
            {isLoggedInUserAccountOwnerAndOlderThan34 && (
                <WarningMessage
                    id="bsu-age-warningmessage"
                    className="bsu-additional-info"
                    text={translated.bsuDetails.ageWarningMessage}
                    icon={IconTypes.INFO_24}
                />
            )}
        </>
    );
};

export default AccountBSUMessage;
